<span>Show</span>
<select name="selectedSize" [(ngModel)]='selectedSize' (change)="optionSelected($event.target.value)">
  <option *ngFor="let size of internalSource" [value]="size">
    {{size}}
  </option>
</select>
<span>entries per page</span>
